module.exports = __webpack_public_path__ + "static/media/Sunny.33794726.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/weather/Sunny.svg
// module id = 53
// module chunks = 0